import { createSelector } from 'reselect';
import { getEntityById, nullSafeGetOrElse } from '../utils/DataAccessUtils';
import { getSanitisedWorkOrder } from '../utils/WorkOrderUtils';

// Input selectors
const getWorkOrders = (state) => state.work_orders;
const getIsClientView = (state) => state.clientView.isClientView;
const getWorkOrderIdFromProps = (_, ownProps) => ownProps.match.params.id;

export const getWorkOrderSelector = createSelector(
	[getWorkOrders, getIsClientView, getWorkOrderIdFromProps],
	(workOrders, isClientView, id) => {
		const workOrder = getEntityById(id, workOrders);

		if (workOrder.id) {
			return getSanitisedWorkOrder(workOrder, isClientView);
		}
		return workOrder;
	}
);
